module.exports = __webpack_public_path__ + "img/feat-phone.svg";